import React from 'react';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';

import CancelIcon from '@material-ui/icons/Cancel';
import {Tools} from './Tools';
import './Publish.scss';

interface Props {
    mes?: string,
    yes(status:boolean):void,
    no():void,
    isOpen:boolean,
}
const Publish = (props:Props)=> {
    const yes0 = ()=>{
        props.yes(false);
    }
    const yes1 = ()=>{
        props.yes(true);
    }
    return (
        <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={props.isOpen}
            onClose={props.no}
        >
            <div style={Tools.getModalStyle()} className="alert">
                <div className="dialogRoot">
                    <div style={{marginBottom:"1em"}}>
                        保存します。<br/>
                        良い？<br/>
                    </div>
                    <Button variant="outlined" color="primary" style={{width:"60%"}} onClick={yes0}>下書き保存</Button>
                    <Button variant="contained" color="secondary" style={{width:"40%"}} onClick={yes1}>公開</Button>
                    <IconButton aria-label="close" onClick={props.no} color="primary" style={{position:"absolute",top:"-0.3em",right:"-0.3em"}}>
                        <CancelIcon/>
                    </IconButton>
                </div>
            </div>
        </Modal>
    );
}

export default Publish;
